export const CASE_STUDIES_BADGE = "CREATOR CASE STUDIES";
export const CASE_STUDIES_TITLE = "Real businesses running on Exly";
export const CASE_STUDIES_DESCRIPTION =
  "The kind of creators you'll be referring, and what they've built on the platform.";

export const READ_CASE_STUDY_CTA_LABEL = "Read case study";
export const CREATOR_PHOTO_FALLBACK_LABEL = "Creator photo";

export const CASE_STUDY_CARDS = [
  {
    id: "roshita-pandey",
    category: "Astrology · Healing",
    name: "Roshita Pandey",
    subtitle: "Astro Roshita · Patna",
    description:
      "Moved tarot, spells, kundli reports and her flagship Lama Fera healing onto one Exly storefront, with EMI on premium packages and automated retargeting for dropped payments.",
    photoUrl:
      "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/referral_page/roshita-pandey.png",
    linkUrl:
      "https://cokhush.exlyapp.com/new-offer/f82c8d5a-2803-4331-80cb-df0609cfc3c4",
    isFeatured: false,
  },
  {
    id: "Deepti",
    category: "Dance · Fitness",
    name: "Deepti",
    subtitle: "Dance with Deepti",
    description:
      "YouTube creator with 1M+ subscribers who runs her dance programs and community on Exly.",
    photoUrl:
      "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/referral_page/deepti.png",
    linkUrl:
      "https://cokhush.exlyapp.com/new-offer/3d7ac799-79a9-4fda-bddf-a98c5a397807",
    isFeatured: false,
  },

  {
    id: "sumit-dubey",
    category: "Fitness",
    name: "Sumit Dubey",
    subtitle: "Fitness Coach · 17 years",
    description:
      "A 17-year fitness veteran who left his corporate job just before COVID, automated his entire coaching business on Exly, and grew revenue 9.7× in ten months.",
    photoUrl:
      "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/referral_page/sumit-dubey.png",
    linkUrl:
      "https://cokhush.exlyapp.com/new-offer/fefcd7d4-7540-45da-82b1-0273950d5399",
    isFeatured: false,
  },
];
